import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { uri } from "../../../help/Api";

import LoadingPage from "../../../services/LoadingPage";

import * as _ from "lodash";
import { stElemnt } from "../../../St/Reviews/cStyle";
import { ButtonBase, Grid, Typography } from "@material-ui/core";
import { useInvAF } from "../../../St/Reviews/UseStyle";
import { sto } from "../../../Context/InshData";
import HeaderCash from "./HeaderCash";
import BodyCash from "./BodyCash";
import FooterCash from "./FooterCash";
import BodyCashier1 from "./BodyCashier1";
function BillPage(props) {
    // const { locInv, found, sta, inv, chunk } = props;
    const { locInv, found, sta, inv, data, onUnmountComplete } = props;
    const clas = useInvAF();
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
    const style = {
        width: "85mm",
        backgroundColor: "#fff",
    };
    const stylle = {
        width: "85mm",
        backgroundColor: "#fff",
    };
    return (
        <div item container justifyContent='center'>
            {/* <Fragment> */}
                <HeaderCash
                    info={found}
                    onUnmountComplete={onUnmountComplete} />
                {/* <BodyCash */}
                {premiApp?.cashirTemplate == 6 ?
                    (
                        <BodyCash
                            data={data ?? []}
                            sta={sta}
                            locInv={locInv}
                            onUnmountComplete={onUnmountComplete}
                        />
                    ) :
                    (
                        <BodyCashier1
                            data={data ?? []}
                            sta={sta}
                            locInv={locInv}
                            onUnmountComplete={onUnmountComplete}
                        />
                    )}

                <FooterCash found={found} inv={inv} sta={sta} locInv={locInv} onUnmountComplete={onUnmountComplete} />
            {/* </Fragment> */}
        </div>
    );
}
function CashairNoTaxCon(props) {
    const { onUnmountComplete } = props;
    const locInv = JSON.parse(localStorage.getItem("datainv")) || {};
    const [found, setFound] = useState({});
    const [sta, setSta] = useState({});
    const [inv, setInv] = useState({});
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);


    let count_id = 0;
    const getInfo = async () => {
        // alert('getInfo')
        const tb = {
            GetFoundation: true,
            Rpt_Inv: true,
            wait: true,
            SettInvsApp: true,
            parms: {
                lprocid: locInv.proc_id,
                ibranchid: sto.branchi,
                branch: sto.branchi,
                iFoundid: 1,
                sProcTypeInvProc: locInv.ProcTypeInvProc,
            },
            autos: {},
        };
        console.log(tb);
        await axios
            .post(`${uri}Res`, tb)
            .then((res) => {
                setSta({ info: res.data.RptInv, tot: res.data.infoBill, StngIA: res.data.SettInvsApp });
                setData(res.data.RptInv);
                setFound(res.data.Found);
            })
            .catch((error) => {
                console.log("catch");
            });
    };
    const getInv = async () => {
        axios
            .get(uri + `InvForFatora?proc_id=${locInv.proc_id}`)
            .then((res) => {
                console.log("the inve for fatoora", res.data);
                setInv(res.data);
            })
            .catch((error) => { });
    };
    useEffect(() => {
        setTimeout(async () => {
            await getInfo();
            await getInv();
            setLoading(false);
            //onUnmountComplete();
        }, 0);
    }, []);

    if (!found || !sta || loading) return <LoadingPage />;


    return (
        <Typography component="div" justifyContent='center'  >
            <BillPage
                {...{
                    locInv,
                    found,
                    sta,
                    inv,
                    data: data,
                    onUnmountComplete,
                }}
            />
        </Typography>
    );
}
export default CashairNoTaxCon;
